export default __webpack_public_path__ + "static/experience2-bg-696faa09ae31aff8d854f9d97c239429.png";